module.exports = __webpack_public_path__ + "img/album05_20.85c35da6.jpg";